var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 18.667a.833.833 0 0 1-.833.833H5.333a.833.833 0 0 1-.833-.833V9.909a.833.833 0 0 1 .322-.659l6.666-5.185a.834.834 0 0 1 1.024 0l6.666 5.185a.832.832 0 0 1 .322.659v8.758Zm-1.667-.833v-7.519L12 5.78l-5.833 4.536v7.519h11.666Z",
    fill: "#1D1737"
  })));
};
export default SvgHome;